module.exports = __webpack_public_path__ + "static/media/Retunelogo.ee960d9b.png";